<style>
  @import url("https://fonts.googleapis.com/css2?family=Satisfy&display=swap");
</style>
<div class="container">
  <a href="https://www.renovationunderwriting.com/"
    ><img class="brand-logo" src="/assets/img/ru-geo.svg" alt=""
  /></a>
</div>
<router-outlet></router-outlet>
<footer>
  <span class="copywright"
    >Renovation Underwriting {{ date | date : "y" }}</span
  >
  <a href="https://vitaledigital.co.uk" class="poweredBy"
    >Powered by Vitale-Digital v2.0</a
  >
</footer>
